// Copyright (c) Move Closer 2022.

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const DELIVERY_DETAILS_STEP_COMPONENT_KEY = 'DeliveryDetailsStepComponent'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const DELIVERY_DETAILS_STEP_COMPONENT_CONFIG_MAP = {
  input: {
    hasAnimatingLabel: true
  }
}
